import React from 'react';
import styled from 'styled-components';

import useUI from 'hooks/use-ui';

import CoreMenuHeader from './core-menu-header';
import StoreFrontHeader from './store-front-header';

export default function Header(props) {
  const { isStoreFront, isKiosk } = useUI();

  return (
    <Container>
      {(isStoreFront || isKiosk) && <StoreFrontHeader />}
      <CoreMenuHeader {...props} />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;
